var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.0918,
    y: 2.04883,
    width: 21.5393,
    height: 28.0011,
    rx: 2,
    fill: "url(#paint0_linear_646_10905)",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.93994,
    width: 23.2624,
    height: 28.1088,
    rx: 3,
    fill: "url(#paint1_linear_646_10905)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.98438,
    y: 9.80273,
    width: 8.61572,
    height: 2.15393,
    rx: 1.07697,
    fill: "#E9F4FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.98438,
    y: 14.1108,
    width: 15.0775,
    height: 2.15393,
    rx: 1.07697,
    fill: "#E9F4FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.98438,
    y: 18.4185,
    width: 15.0775,
    height: 8.61572,
    rx: 1,
    fill: "#E9F4FF",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_646_10905",
    x1: 18.8614,
    y1: 2.04883,
    x2: 18.8614,
    y2: 23.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E97EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DB9EE",
    stopOpacity: 0.51
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_646_10905",
    x1: 15.6312,
    y1: 3.93994,
    x2: 15.6312,
    y2: 32.0487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E97EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DB9EE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCenter);
export default "https://cdn.d2cgo.com/dtc_center/v19/so_assets/static/media/contentCenter.5b163fb410cc9fee9d8d103808a019ed.svg";
export { ForwardRef as ReactComponent };